import { Controller } from "@hotwired/stimulus";
import { get } from '@rails/request.js'

// Connects to data-controller="inventory--site-to-site-transfer"
export default class extends Controller {
  static targets = [
    "approverSelect",
    "recipientSelect",
    "recipientSpinner",
    "inventorySelect",
    "siteSelect",
    "workspaceSelect",
    "targetInventoryName",
    "targetInventorySpinner",
    "targetInventoryFields",
    "targetWorkspaceSpinner",
    "targetWorkspaceField",
    "otherRecipientName",
    "submit",
    "otherRecipientNameDiv",
    "trackingNumber",
    "carrierSelect"
  ];

  static values = {
    independent: String,
    inventoryId: String
  }

  connect() {
    this.toggleSubmit()
  }
  
  toggleSubmit(){
    const siteValue = this.siteSelectTarget.value
    const approverValue = this.approverSelectTarget.value
    const recipientValue = this.hasRecipientSelectTarget && this.recipientSelectTarget.value && (this.recipientSelectTarget.value != "0" || this.otherRecipientNameTarget.value)
    
    let preventSubmit = !siteValue || !approverValue || !recipientValue

    if (this.independentValue){
      const targetInventoryMissing = this.hasInventorySelectTarget && this.inventorySelectTarget.value == ""
      const targetNameMissing = this.hasTargetInventoryNameTarget && this.targetInventoryNameTarget.value == ""
      const workspaceMissing = this.hasWorkspaceSelectTarget && this.workspaceSelectTarget.value == ""
      preventSubmit = preventSubmit || targetInventoryMissing || targetNameMissing || workspaceMissing
    }
    
    if (preventSubmit) {
      this.submitTarget.setAttribute('disabled', "true")
      this.submitTarget.classList.add("disabled")
    } else {
      this.submitTarget.removeAttribute('disabled')
      this.submitTarget.classList.remove("disabled")
    }
  }

  handleSiteSelect(e){
    this.toggleSubmit()
    const siteID = e.target.value
    if (this.independentValue == "true"){
      if (siteID === ""){
        this.targetWorkspaceFieldTarget.classList.add("d-none")
        this.targetInventoryFieldsTarget.classList.add("d-none")
      } else {
        if (this.hasTargetWorkspaceSpinnerTarget){this.targetWorkspaceSpinnerTarget.classList.remove("d-none");}
        get(`/inventories/${this.inventoryIdValue}/fetch_target_workspaces?target_site_id=${siteID}`, { responseKind: 'turbo-stream' })
      }
    } else {
      this.recipientSpinnerTarget.classList.remove("d-none");
      get(`/inventories/${this.inventoryIdValue}/fetch_recipients?target_site_id=${siteID}`, { responseKind: 'turbo-stream' })
      
    }
  }

  handleWorkspaceSelect(e){
    this.toggleSubmit()
    const workspaceID = e.target.value
    if (workspaceID === ""){
      this.targetInventoryFieldsTarget.classList.add("d-none")
    } else {
      this.targetInventorySpinnerTarget.classList.remove("d-none");
      this.recipientSpinnerTarget.classList.remove("d-none");
      get(`/inventories/${this.inventoryIdValue}/fetch_target_inventories?target_workspace_id=${workspaceID}`, { responseKind: 'turbo-stream' })
    }
  }

  handleInventorySelect(e){
    this.toggleSubmit()
    this.targetInventoryNameTarget.classList.toggle("d-none", e.target.value != "new");
  }

  handleRecipientSelect(e){
    if (this.recipientSelectTarget.value == "0"){
      this.otherRecipientNameDivTarget.classList.remove("d-none")
      this.otherRecipientNameTarget.setAttribute("required", true)
    } else {
      this.otherRecipientNameDivTarget.classList.add("d-none")
      this.otherRecipientNameTarget.removeAttribute("required")
    }
    this.toggleSubmit()
  }

  handleCarrierSelect(){
    if (this.carrierSelectTarget.value == ""){
      this.trackingNumberTarget.removeAttribute("required")
    } else {
      this.trackingNumberTarget.setAttribute("required", true)
    }
    this.toggleSubmit()
  }

}
